import FacilityInformation from "../helpers/FacilityInformation";
import {getAppState} from "../helpers/tools";

/**
 *
 * @param location
 * @returns {Function}
 */
export const setLocation = (location) => {
  return dispatch => {
    dispatch({type: "SET_LOCATION", data: location});
  }
};

/**
 *
 * @param location
 * @returns {Function}
 */
export const fetchLocation = (location) => {
  return (dispatch, getState) => {
    dispatch({type: "FETCH_LOCATION", data: location});
    const state = getAppState( getState() );
    try {
      const details = new FacilityInformation(location, state.actions.history);
      dispatch({
        type: "FETCH_LOCATION_FULFILLED",
        data: details.getHTML(),
      })
    } catch (e) {
      dispatch({
        type: "FETCH_LOCATION_REJECTED",
        data: e
      });
    }
  }
};
